import { useFormContext } from 'react-hook-form'

import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

import { SchemaType } from '@/components/forms/AddShareclassForm/AddShareclassForm.schema'

export interface AddShareclassFormFieldsProps {}

export const AddShareclassFormFields: React.FC<AddShareclassFormFieldsProps> = ({}) => {
  const { control, formState, register } = useFormContext<SchemaType>()

  return (
    <div className={'flex flex-col gap-4'}>
      <FormField
        name="fund_name"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Fund Name</FormLabel>
              <Input
                inputSize={'sm'}
                className={'w-full'}
                disabled={formState.isSubmitting}
                value={value}
                {...register('fund_name')}
              />
            </FormItem>
          )
        }}
      />
      <FormField
        name="shareclass_code"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Shareclass Code</FormLabel>
              <Input
                inputSize={'sm'}
                className={'w-full'}
                disabled={formState.isSubmitting}
                value={value}
                {...register('shareclass_code')}
              />
            </FormItem>
          )
        }}
      />
      <FormField
        name="shareclass_sleeve"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Shareclass Sleeve</FormLabel>
              <Input
                inputSize={'sm'}
                className={'w-full'}
                disabled={formState.isSubmitting}
                value={value}
                {...register('shareclass_sleeve')}
              />
            </FormItem>
          )
        }}
      />
      <FormField
        name="isin"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>ISIN</FormLabel>
              <Input
                inputSize={'sm'}
                className={'w-full'}
                disabled={formState.isSubmitting}
                value={value}
                {...register('isin')}
              />
            </FormItem>
          )
        }}
      />
    </div>
  )
}
